import { Platform } from 'react-native'
import { tv } from 'tailwind-variants'

import { body2, h4 } from '@ui-kit/core/typography'

// The App MVP design applies to native only; web keeps its current look.
export const IS_NATIVE = Platform.OS !== 'web'

export const searchableList = tv({
  slots: {
    titleContainer: 'mb-4',
    titleText: h4(),
    searchContainer: 'mb-4',
    searchInput:
      'font-inter focus:ring-primary-500 rounded-full border-0 bg-grey-100 px-4 py-3 text-base focus:ring-2 web:outline-none',
    scrollContainer: 'web:max-h-[70vh]',
    sectionHeader: 'pb-2 pt-4',
    sectionHeaderText: 'font-inter-semibold text-sm text-grey-500',
    optionItem:
      'flex-row items-center gap-x-3 border-b border-grey-200 py-4 hover:bg-grey-100 web:transition-colors',
    imageContainer: 'h-6 w-6 items-center justify-center overflow-hidden rounded-full',
    image: 'h-full w-full',
    labelContainer: 'flex-1',
    optionLabel: body2(),
    emptyContainer: 'py-4',
    emptyText: 'text-center text-grey-500',
  },
  variants: {
    hasImages: {
      true: {
        optionItem: 'gap-x-4 border-b-0 py-3',
        imageContainer: 'h-16 w-16 rounded-2xl bg-grey-100',
        image: 'h-10 w-10',
        optionLabel: body2({ className: 'font-inter-semibold' }),
      },
    },
    isLast: {
      true: {
        optionItem: 'border-b-0',
      },
    },
    isSelected: {
      true: {
        optionItem: 'bg-grey-100',
      },
    },
    isDisabled: {
      true: {
        optionItem: 'opacity-50 hover:bg-transparent web:cursor-not-allowed',
      },
    },
    isGrouped: {
      true: {
        optionItem:
          'mb-2 min-h-[69px] rounded-md border-b-0 bg-grey-100 px-3 py-2 hover:bg-grey-200',
        imageContainer: 'h-[50px] w-[50px] rounded-full bg-white',
        image: 'h-full w-full',
      },
    },
    isNative: {
      true: {
        searchContainer: 'flex-row items-center gap-x-0.5 rounded-full bg-grey-100 px-2.5 py-2',
        searchInput: 'flex-1 rounded-none bg-transparent p-0 font-inter-medium text-xs',
      },
    },
  },
  defaultVariants: { isNative: IS_NATIVE },
  compoundVariants: [
    {
      isGrouped: true,
      isSelected: true,
      class: { optionItem: 'bg-grey-200' },
    },
    {
      isGrouped: true,
      isDisabled: true,
      class: { optionItem: 'hover:bg-grey-100' },
    },
    {
      isNative: true,
      isGrouped: true,
      class: {
        sectionHeader: 'pb-2.5 pt-0',
        optionItem: 'mb-2.5 min-h-[69px] gap-x-2.5 overflow-hidden px-5 py-0 active:opacity-70',
        imageContainer:
          '-ml-5 h-auto w-[91px] self-stretch overflow-visible rounded-none bg-transparent',
        image: 'absolute left-2.5 top-[5px] h-[72px] w-[72px]',
        optionLabel: 'font-inter-medium',
      },
    },
    {
      isNative: true,
      isGrouped: true,
      isSelected: true,
      class: { optionItem: 'bg-grey-100' },
    },
  ],
})
